import { css } from 'linaria';

const root = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--rounding-m);
  width: 32px;
  height: 24px;
  cursor: pointer;
  background-color: var(--control-minor);
`;

const active = css`
  background-color: var(--control-primary);
`;

const icon = css`
  svg {
    width: 13px !important;
  }
`;

export { root, active, icon };
